import api from '../../../lib/Api'
import * as actions from './actions'
import { addNotification } from '../../notifications'

export const handleAddSSOIntegration = integrationParameters => {
  return async function(dispatch) {
    dispatch(actions.insertingDomainProvider())
    const {
      displayName,
      activeDate,
      endDate,
      domains,
      provider,
    } = integrationParameters

    if (provider && domains && displayName && activeDate) {
      try {
        const domainList = domains.replace(' ', '').split(',')
        const response = await api.post(`/domainprovider`, {
          displayName,
          activeDate,
          endDate,
          domains: domainList,
          provider,
        })

        dispatch(
          addNotification({
            color: 'success',
            text: `You have sucessfully inserted SSO Integration for ${displayName} district`,
          }),
        )
        const data = response.data !== '' ? response.data : null
        dispatch(actions.insertingDomainProviderSuccess(data))
      } catch (error) {
        const { response } = error
        const { data } = response || {}
        const { detail } = data || {}
        const errorMessage = detail || error.toString()
        dispatch(
          addNotification({
            color: 'danger',
            text: errorMessage,
          }),
        )
        dispatch(actions.insertingDomainProviderError(errorMessage))
      }
    } else {
    }
  }
}
